//华东重机
import Overview from './overview.vue';
import Full from './full.vue';
import MobOverview from '@/rebuild/materials/shared/quote/mobile/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/quote/mobile/MobFull.vue';


export const componentMap = {
	overview: Overview,
	full: Full,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 